import React, { useState, useEffect } from "react";
import "../App.css";
import { getTokenInternal } from "./useToken";
import { useNavigate } from "react-router";
import Nav from "./Navigation.js";

const CreateEventForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });
  const [eventCreated, setEventCreated] = useState(false);

  const [token, setToken] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchToken = async () => {
      try {
        const fetchedToken = await getTokenInternal();
        setToken(fetchedToken);
      } catch (error) {
        console.error("Error fetching token:", error);
      }
    };

    fetchToken();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (!token) {
        console.error("Token is not available.");
        return;
      }

      const response = await fetch(
        `${process.env.REACT_APP_API_HOST}/api/events/create`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token.access_token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        const data = await response.json();
        setEventCreated(true);
        // Set a timer to clear the message after 5 seconds
        setTimeout(() => {
          setEventCreated(false);
        }, 5000);
      } else {
        console.error("Failed to create item:", response.status);
        setEventCreated(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setEventCreated(false);
    }
  };

  if (
    !token ||
    (token.account.role !== "management" && token.account.role !== "owner")
  ) {
    navigate("/");
    return null; //
  }

  return (
    <div className="text-white">
      <Nav></Nav>
      {eventCreated && (
        <p className="text-green-500 text-center">Item Created!</p>
      )}
      <div className="max-w-md mx-auto my-8 block font-bold mb-2">
        Events (Primary, Halloween, Valentines, etc)
      </div>
      <form onSubmit={handleSubmit} className="max-w-md mx-auto my-8">
        <div className="mb-4">
          <label className="block text-sm font-bold mb-2">
            Name:
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="mt-1 p-2 w-full border text-black rounded-md"
            />
          </label>
        </div>
        <div className="mb-4">
          <label className="block text-white text-sm font-bold mb-2">
            Description:
            <input
              type="text"
              name="description"
              value={formData.description}
              onChange={handleChange}
              className="mt-1 p-2 w-full border text-black rounded-md"
            />
          </label>
        </div>

        <div className="text-center">
          <button
            type="submit"
            className="bg-blue-500 text-white p-2 rounded-md hover:bg-blue-700"
          >
            Create Item
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateEventForm;
